import { ACADEMICS_PLACEHOLDER_FEATURES } from "./academics/academics.placeholders";
import { AcademicYearsFeature } from "./academics/academicYears/academicYears.feature";
import { AdmissionsFeature } from "./academics/admissions/admissions.feature";
import { AttendanceFeature } from "./academics/attendance/attendance.feature";
import { ClassesFeature } from "./academics/classes/classes.feature";
import { ClassStudentMapFeature } from "./academics/classstudentmap/classstudentmap.feature";
import { ClassSubjectMappingFeature } from "./academics/classSubjectMapping/classSubjectMapping.feature";
import { HomeworkAssignmentsFeature } from "./academics/homeworkAssignments/homeworkAssignments.feature";
import { SectionsFeature } from "./academics/sections/sections.feature";
import { StudentsFeature } from "./academics/students/students.feature";
import { StudentsV2Feature } from "./academics/studentsV2/studentsV2.feature";
import { SubjectsFeature } from "./academics/subjects/subjects.feature";
import { TeacherAssignmentFeature } from "./academics/teacherAssignment/teacherAssignment.feature";
import { TimetableFeature } from "./academics/timetable/timetable.feature";
import { TimetableV2Feature } from "./academics/timetableV2/timetableV2.feature";
import { ADMINISTRATION_FEATURES } from "./administration/administration.features";
import { AI_FEATURES } from "./ai/ai.features";
import { COMMUNICATION_FEATURES } from "./communication/communication.features";
import { EXAMINATIONS_FEATURES } from "./examinations/examinations.features";
import type { FeatureMetadata } from "./feature.types";
import { FEES_FINANCE_FEATURES } from "./feesFinance/feesFinance.features";
import { HOME_FEATURES } from "./home/home.features";
import { HUMAN_RESOURCES_FEATURES } from "./humanResources/humanResources.features";
import { INFRASTRUCTURE_FEATURES } from "./infrastructure/infrastructure.features";
import { USER_ACCESS_FEATURES } from "./userAccess/userAccess.features";

export type ModuleKey = FeatureMetadata["moduleName"];

export const ACADEMICS_FEATURES = [
  AdmissionsFeature,
  StudentsFeature,
  StudentsV2Feature,
  ClassesFeature,
  SectionsFeature,
  SubjectsFeature,
  TimetableFeature,
  TimetableV2Feature,
  HomeworkAssignmentsFeature,
  AttendanceFeature,
  ClassStudentMapFeature,
  ClassSubjectMappingFeature,
  TeacherAssignmentFeature,
  AcademicYearsFeature,
  ...ACADEMICS_PLACEHOLDER_FEATURES,
] as const satisfies readonly FeatureMetadata[];

export const FEATURES = [
  ...HOME_FEATURES,
  ...AI_FEATURES,
  ...USER_ACCESS_FEATURES,
  ...ACADEMICS_FEATURES,
  ...EXAMINATIONS_FEATURES,
  ...FEES_FINANCE_FEATURES,
  ...HUMAN_RESOURCES_FEATURES,
  ...INFRASTRUCTURE_FEATURES,
  ...COMMUNICATION_FEATURES,
  ...ADMINISTRATION_FEATURES,
] as const satisfies readonly FeatureMetadata[];

export const FEATURES_BY_MODULE = {
  home: HOME_FEATURES,
  ai: AI_FEATURES,
  userAccess: USER_ACCESS_FEATURES,
  academics: ACADEMICS_FEATURES,
  examinations: EXAMINATIONS_FEATURES,
  feesFinance: FEES_FINANCE_FEATURES,
  humanResources: HUMAN_RESOURCES_FEATURES,
  infrastructure: INFRASTRUCTURE_FEATURES,
  communication: COMMUNICATION_FEATURES,
  administration: ADMINISTRATION_FEATURES,
} as const satisfies Record<string, readonly FeatureMetadata[]>;

export function getFeatureByPath(pathname: string): FeatureMetadata | undefined {
  return FEATURES.find(
    (feature) => feature.route?.path === pathname || feature.navigation.path === pathname,
  );
}

export function getFeatureById(id: string): FeatureMetadata | undefined {
  return FEATURES.find((feature) => feature.id === id);
}
